import classNames from 'classnames';
import { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react';

import styles from './CheckBox.module.scss';

export interface CheckBoxProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  children: ReactNode;
  dataTestId?: string;
  reg?: any;
}

export const CheckBox = ({ className, id, children, disabled, dataTestId, reg, ...props }: CheckBoxProps) => {
  return (
    <div className={classNames(styles.CheckBox, { [styles.Disabled]: disabled }, className)} data-testid={dataTestId}>
      <input id={id} type="checkbox" disabled={disabled} {...reg} {...props} />
      <span className={styles.checked}></span>
      <label htmlFor={id}>{children}</label>
    </div>
  );
};
